import Vue from 'vue'
import Router from 'vue-router'
import BookPage from '../view/BookPage/index'
import Login from '../view/Login/index'
import OnlineBook from '../view/OnLineBook/index'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'BookPage',
      component: BookPage
    },
    {
      path: '/OnlineBook',
      name: 'OnlineBook',
      component: OnlineBook
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js